import { useNavigate } from "@solidjs/router";

export type BrandHeaderProps = {
  brandName: string;
};

/**
 * Brand header with back button and brand name
 * Design: https://www.figma.com/design/uTQhl6K0EfVzl9uxl4Y4o1/Demand-master?node-id=106-782
 */
export function BrandHeader(props: BrandHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div class="flex h-9 items-center gap-3 px-1">
      {/* Back Button */}
      <button
        onClick={handleBack}
        class="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--color-alpha-neutral-16)] fill-text-normal-primary "
      >
        <BackIcon />
      </button>

      {/* Brand Name (uppercase, centered) */}
      <div class="flex-1 text-center text-caption-semi-bold uppercase tracking-[0.4px] text-text-normal-primary">
        {props.brandName}
      </div>

      {/* Placeholder for right side (hidden) */}
      <div class="h-9 w-9 opacity-0" />
    </div>
  );
}

function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.52334 9.16591H16.6667V10.8326H6.52334L10.9933 15.3026L9.81501 16.4809L3.33334 9.99924L9.81501 3.51758L10.9933 4.69591L6.52334 9.16591Z"
        class="fill-text-normal-primary"
      />
    </svg>
  );
}
